import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { IAuthService } from 'src/app/core/services/api/contracts/auth-service';
import { Subscription } from 'rxjs';
import { DismissReason } from 'src/app/shared/extensions/ng-active-modal/dismiss-reason';

@Component({
  selector: 'app-qr-login',
  templateUrl: './qr-login.component.html',
  styleUrls: ['./qr-login.component.scss']
})
export class QrLoginComponent implements OnInit, OnDestroy {

  id: string;
  value: any;
  status: string = 'Waiting for login...';
  verificationMessage: { invitationId: string, invitationContent: string };
  isVerificationComplete: boolean = false;
  intervalId: any;
  pollingSubscription?: Subscription;

  constructor(
    public activeModal: NgbActiveModal,
    @Inject("IAuthService") private authService: IAuthService,
  ) {}

  ngOnInit(): void {
    this.authService.getVerificationMessage().subscribe({
      next: (response) => {
        this.verificationMessage = response;
        this.id = response.invitationId;
        this.setQrCode(response.invitationContent);
        this.startPollingStatus(this.id);
      },
      error: (err) => console.error('[QrLogin] Error al obtener verificación:', err)
    });
  }


  startPollingStatus(id: string) {
    this.intervalId = setInterval(() => this.fetchStatus(id), 1000);
  }

  private fetchStatus(id: string): void {
  if (this.isVerificationComplete) return; 

  this.pollingSubscription?.unsubscribe(); 

  this.pollingSubscription = this.authService.getStatus(id).subscribe({
    next: (response) => {
      if (response.status === 'success') {
        this.status = 'Login successful';
        this.isVerificationComplete = true;
        clearInterval(this.intervalId);

        this.activeModal.close({ success: true, data: response.data });
      } else if (response.status === 'pending') {
        this.status = 'Waiting for login...';
      } else {
        this.status = 'Error';
  
      }
    },
    error: (error) => {
      console.error('Error al consultar status:', error);
      this.status = 'Error connecting to server';
    }
  });
}

  setQrCode(data: string) {
    this.value = data.replace("didcomm://", "extrimian://");
  }

 close() {
  clearInterval(this.intervalId);
  this.activeModal.close({ success: false });
}

private closeModalWithResult(result: any) {
  clearInterval(this.intervalId);
  this.activeModal.close(result);
}

  ngOnDestroy() {
    clearInterval(this.intervalId);
    this.pollingSubscription?.unsubscribe();
  }
}
